module.exports = __webpack_public_path__ + "img/1.676ae55d.jpg";